export enum AnnouncementsRouterLinks {
  Edit = 'edit',
  Add = 'add',
  Manage = 'announcements',
  List = 'announcements-list',
}
